import { Component, OnInit } from '@angular/core';
import { filter, Observable, tap } from 'rxjs';

//* Core
import { AlertService, ScreenSizeService, UserContextService } from '@core/services';

//* Base
import { DashboardService } from '@dashboard/dashboard.service';

//* Shared
import { fadeInOut } from '@shared/animations';
import { Caption, Dashboard } from './models';

@Component({
  selector: 'sp-dashboard',
  template: `
    <sp-page-content-container>
      <div *ngIf="dashboard$ | async as dashboard" class="dashboard-grid-container" [@fadeInOut]>
        <ng-container *ngIf="userContext$ | async as userContext">
          <ng-container *ngIf="dashboardWidgets$ | async as dashboardWidgets">
            <!--//? Mobile Tax Widget -->
            <ng-container *ngIf="isSmallScreens$ | async">
              <div class="dashboard-mobile-widget-container">
                <sp-widget-grid
                  [widgets]="dashboardWidgets.taxOnly"
                  [evenGrid]="true"
                  [@fadeInOut]
                  [userContext]="userContext">
                </sp-widget-grid>
              </div>
            </ng-container>

            <!--//? Details Container -->
            <!-- //* Details -->
            <sp-dashboard-details
              *ngIf="dashboard.paystubInfos.length"
              [dashboard]="dashboard"
              [userContext]="userContext"
              [@fadeInOut]>
            </sp-dashboard-details>

            <!--//* No Details -->
            <sp-dashboard-no-paystubs
              *ngIf="!dashboard.paystubInfos.length"
              [@fadeInOut]
              [userContext]="userContext">
            </sp-dashboard-no-paystubs>

            <!--//? Widgets Grid Container -->
            <div class="dashboard-widgets-container">
              <sp-widget-grid
                [widgets]="dashboardWidgets.dashboard"
                [evenGrid]="true"
                [@fadeInOut]
                [userContext]="userContext"
                [height]="'100%'">
              </sp-widget-grid>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </sp-page-content-container>
  `,
  styleUrls: ['./dashboard.component.scss'],
  animations: [fadeInOut],
})
export class DashboardComponent implements OnInit {
  dashboard$: Observable<Dashboard>;

  dashboardWidgets$ = this.dashboardService.dashboardWidgets$;
  isSmallScreens$ = this.screenServiceSize.isSmallScreens$;
  isMobile$ = this.screenServiceSize.isMobile$;
  userContext$ = this.userContextService.userContext$;

  constructor(
    private alertService: AlertService,
    private dashboardService: DashboardService,
    private screenServiceSize: ScreenSizeService,
    private userContextService: UserContextService
  ) {}

  ngOnInit() {
    this.dashboard$ = this.dashboardService.dashboard$.pipe(
      tap(dashboard => this.showAlert(dashboard.bannerMessage))
    );
  }

  showAlert(bannerMessage: Caption): void {
    if (bannerMessage) {
      this.isMobile$.subscribe(isMobile => {
        if (isMobile && this.dashboardService.showAlert) {
          this.dashboardService.showAlert = false;

          //* wait 1 sec and then show banner.
          setTimeout(() => {
            this.alertService.banner(
              `You are bringing home ${bannerMessage.amount} on ${bannerMessage.date}.`
            );
          }, 1000);
        }
      });
    }
  }
}
